class Holiday {
    date;
    localName;
    name;
    constructor(holidayJson) {
        this.date = window.dateHandler.formatDateNoTime(holidayJson.date);
        this.localName = holidayJson.localName;
        this.name = holidayJson.name;
    }
}
export default Holiday;
